import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Spin, Tooltip } from 'antd';
import Exceljs from 'exceljs';
import FileSaver from 'file-saver';
import { debounce } from 'lodash';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import qs from 'query-string';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import LoanService from '../../../Service/LoanService';
import { capitalizeFirstLetter, CommaSeparator, convertToPhilippinesTime } from '../../../AppUtil/AppUtil';
import { hot } from 'react-hot-loader';

class Table extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			_data: [],
			_totalRowsCount: 0,
			_currentPage: 0,
			_globalSearchText: '',
			_limit: 10,
			_order:
				this.props.dataSourceName === 'emails' || this.props.dataSourceName === 'sms' ? 'key' : 'creation_date',
			_orderDir: 'desc',
			_response: [],
			_queryUrl: '',
			_uniqueIdsForLoan: [],
			_modifiedPage: false,
			_paginationButtonClicked: false,
			_paginationQuery: '',
			principal: 0,
			_defaultQuery: `channel=&type=all&status=PENDING,APPROVE,COMPLETED,DECLINE&state=PENDING,APPROVE,COMPLETED,PAID,DECLINE&fromDate=${moment()
				.subtract(3, 'month')
				.startOf('month')
				.format('YYYY-MM-DD')}&toDate= ${moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')}&`
		};
	}

	setTableData = async () => {
		this.setState({ _isLoading: true });
		if (this.props.customFilterQuery) {
			await this.setState({ _modifiedPage: true, _paginationQuery: this.props.customFilterQuery });
		}
		const queryParam = {
			limit: this.state._limit,
			order: this.state._order,
			orderDir: this.state._orderDir,
			page: !this.state._paginationButtonClicked ? 0 : this.state._currentPage,
			filter: this.state._globalSearchText
		};
		let queryUrl = '?';
		for (const key of Object.keys(queryParam)) {
			if (queryParam[key] || key === 'page') {
				if (key === 'page') {
					queryUrl += `${key}=${queryParam[key] + 1}&`;
					continue;
				}
				queryUrl += `${key}=${queryParam[key]}&`;
			}
		}

		if (this.props.match.path === '/admin/transactions') {
			if (this.state._modifiedPage === false) {
				queryUrl += this.state._defaultQuery;
			} else {
				queryUrl += this.props.customFilterQuery ? this.props.customFilterQuery : this.state._paginationQuery;
			}
		} else {
			queryUrl += this.props.customFilterQuery;
		}

		const response = await this.props.dataSourceHandler(queryUrl);
		let idsForLoan = [];

		if (response && response[this.props.dataSourceName]?.length !== 0) {
			if (this.state._response.table === 'LOAN_INSTALLMENTS' || this.state._response.table === 'LOANS') {
				const uniqueIds = [];

				response[this.props.dataSourceName].forEach(item => {
					if (item.created_by !== null) uniqueIds.push(item.created_by);
					if (item.accepted_by !== null) uniqueIds.push(item.accepted_by);
					// if (item.email_creator !== null) uniqueIds.push(item.email_creator);
					// if (item.email_acceptor !== null) uniqueIds.push(item.email_acceptor);
				});
				const uniqueSet = new Set(uniqueIds);
				const uniqueValues = Array.from(uniqueSet);

				// Create an array to store all the promises
				const promises = [];

				// Iterate over uniqueValues and create promises for each request
				for (let i = 0; i < uniqueValues.length; i++) {
					const promise = LoanService.getUserLoansByUserId(
						uniqueValues[i],
						'?limit=10&order=creation_date&orderDir=desc&state=PENDING,DECLINE,APPROVE,POST_MODIFIED,PAYMENTS_STOPED,PRE_MODIFIED,COMPLETED,DELETED'
					);
					promises.push(promise);
				}

				// Execute all promises in parallel
				const loansIdsArray = await Promise.all(promises);

				// Flatten the arrays of loansIds from each response
				idsForLoan = loansIdsArray.flatMap(loansIds => loansIds.loans);
			}
		}

		// Update state with filtered data
		// Update state with filtered data
		this.setState({
			_uniqueIdsForLoan: idsForLoan,
			_queryUrl: queryUrl,
			_response: response || [],
			_data: response ? response[this.props.dataSourceName] : [],
			_totalRowsCount: response ? response.total : 0,
			_isLoading: false,
			_paginationButtonClicked: false
		});
	};

	globalSearchHandler = async searchValue => {
		await this.setState({ _currentPage: 0, _globalSearchText: searchValue });
		this.setTableData();
	};

	changePageHandler = async pageNo => {
		const currentQuery = qs.parse(window.location.search);
		currentQuery.page = pageNo;
		this.props.history.push({
			search: qs.stringify(currentQuery)
		});
		await this.setState({ _currentPage: pageNo, _paginationButtonClicked: true });
		this.setTableData();
	};

	propsUpdateHandler = async tableState => {
		if (this.props.match.path === '/admin/transactions') {
			if (this.props.customFilterQuery && !this.state._paginationButtonClicked) {
				tableState.page = 0;
			}
		}
	};

	searchCloseHandler = async () => {
		await this.setState({ _currentPage: 0 });
		this.setTableData();
	};

	getMuiTheme = () =>
		createMuiTheme({
			overrides: {
				MUIDataTableHeadCell: {
					root: {
						fontSize: '15px',
						fontWeight: 'bold',
						textAlign: 'center'
					},
					toolButton: {
						margin: '0 auto'
					},
					sortAction: {
						margin: '0 auto'
					}
				},
				MUIDataTableBodyCell: {
					root: {
						textAlign: 'center'
					}
				}
			}
		});

	// retainStateFromQueryUrl = async () => {
	// 	const query = qs.parse(window.location.search);
	// 	console.log('here at retainStateFromQueryUrl');

	// 	await this.setState({
	// 		_limit: Number(query.limit) || 10,
	// 		_order:
	// 			query.order ||
	// 			(this.props.dataSourceName === 'emails' || this.props.dataSourceName === 'sms'
	// 				? 'key'
	// 				: 'creation_date'),
	// 		_orderDir: query.orderDir || 'desc',
	// 		_currentPage: Number(query.page) || 0
	// 	});
	// 	this.setTableData();
	// };

	componentDidMount() {
		const currentQuery = qs.parse(window.location.search);
		currentQuery.page = 0;
		this.props.history.push({
			search: qs.stringify(currentQuery)
		});
		if (!currentQuery.globalSearch) {
			this.setTableData();
		}
		// if (this.props.dataSourceHandler) {
		// 	this.retainStateFromQueryUrl();
		// }
	}

	componentDidUpdate(nextProps) {
		if (nextProps.customFilterQuery !== this.props.customFilterQuery) {
			this.setTableData();
		}
		if (nextProps.forceRender !== this.props.forceRender) {
			this.setTableData();
		}
		// if (nextProps.location.search !== this.props.location.search) {
		// 	if (this.props.dataSourceHandler) {
		// 		setTimeout(() => {
		// 			this.retainStateFromQueryUrl();
		// 		}, 1000);
		// 	}
		// }
	}

	render() {
		if (!this.props.data && !this.state._data) {
			return 'Loading...';
		}

		const { _currentPage, _totalRowsCount, _limit } = this.state;
		let options = {};
		const showDownload = this.props.match.path === '/admin/transactions';
		const { _data } = this.state;
		let transactionData;
		let transactionColumns;

		if (this.props.match.path === '/admin/transactions') {
			transactionColumns = this.props.columns.filter(f => !(f.name === 'details_name'));
			if (
				_data.length !== 0 &&
				this.state._response.table !== 'LOANS' &&
				this.state._response.table !== 'LOAN_INSTALLMENTS' &&
				this.state._response.table !== 'ALL TRANSACTIONS'
			) {
				transactionColumns = transactionColumns.filter(
					f =>
						f.name !== 'sender_first_name' &&
						f.name !== 'sender_last_name' &&
						f.name !== 'receiver_first_name' &&
						f.name !== 'receiver_last_name' &&
						f.name !== 'id'
				);
				for (let i = 0; i < transactionColumns.length; i++) {
					if (transactionColumns[i].name === 'transfer_type') {
						transactionColumns[i].label = 'Type';
					}
				}
			}
			if (this.state._response.table !== 'LOANS' && this.state._response.table !== 'LOAN_INSTALLMENTS') {
				transactionColumns.splice(2, 0, {
					name: 'customer_name',
					label: 'Customer Name',
					options: {
						// sort: true,
						sort: false,
						customBodyRender: value => {
							return value || 'N/A';
						}
					}
				});
			}
			transactionData = _data.map((m, index) => {
				const capitalizedChannel = m.channel ? m.channel?.toUpperCase() : 'N/A';

				m.channel = capitalizedChannel;

				// const timeInput = m.cashout_date || m.topup_date || m.start_date || m.created_at;
				// const timeObj = new Date(timeInput);
				// const month = timeObj.toLocaleString('en-US', { month: 'short' });
				// const day = timeObj.getDate();
				// const year = timeObj.getFullYear();
				// let hour = timeObj.getHours();
				// const amPM = hour < 12 ? 'AM' : 'PM';
				// hour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
				// const minutes = timeObj.getMinutes();
				// const formattedDateTime = `${month} ${day} ${year} ${hour}:${minutes
				// 	.toString()
				// 	.padStart(2, '0')} ${amPM}`;

				// const timeInput = m.cashout_date || m.topup_date || m.start_date || m.created_at || m.creation_date;
				const timeInput = m.creation_date || m.transfer_date || m.installment_date;
				const timeObj = new Date(timeInput);
				const month = timeObj.toLocaleString('en-US', { month: 'short' });
				const day = timeObj.getUTCDate();
				const year = timeObj.getUTCFullYear();
				let hour = timeObj.getUTCHours();
				const amPM = hour < 12 ? 'AM' : 'PM';
				hour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
				const minutes = timeObj.getUTCMinutes();
				const formattedDateTime = `${month} ${day} ${year} ${hour}:${minutes
					.toString()
					.padStart(2, '0')} ${amPM}`;

				if (
					this.state._response.table.toLowerCase() !== 'loans' &&
					this.state._response.table.toLowerCase() !== 'loan_installments' &&
					this.state._response.table.toLowerCase() !== 'all transactions'
				) {
					for (let i = 0; i < this.state._response.subDetails?.length; i++) {
						if (this.state._response.subDetails[i].id === m.user_id) {
							m.transfer_type = this.state._response.subDetails[i].type;
							m.customer_name = capitalizeFirstLetter(
								`${this.state._response.subDetails[i].first_name} ${this.state._response.subDetails[i].last_name}`
							);
						}
					}

					m.action = 'N/A';
					m.amortization_table = 'N/A';

					m.principal = m.principal ?? m.total_amount;

					m.transfer_date = formattedDateTime;
					m.state = this.state._response.transactions[index].status;
				}

				if (this.state._response.table.toLowerCase() == 'all transactions') {
					// if all transactions, change "loan type" into "type" so it's more generic

					for (let i = 0; i < transactionColumns.length; i++) {
						if (transactionColumns[i].name === 'transfer_type') {
							transactionColumns[i].label = 'Type';
						}
					}

					const amountQuery = this.state._response.amountQueries.find(query => query.id == m.installment_id);
					m.principal = m.principal ?? m.total_amount;

					// if cashout or topups

					if (this.state._response.subDetails && m.cashout_date) {
						for (let i = 0; i < this.state._response.subDetails.length; i++) {
							if (this.state._response.subDetails[i].id === m.user_id) {
								m.customer_name = capitalizeFirstLetter(
									`${this.state._response.subDetails[i].first_name} ${this.state._response.subDetails[i].last_name}`
								);
							}
						}

						m.transfer_type = 'CASHOUT';
						m.action = 'N/A';
						m.amortization_table = 'N/A';

						m.principal = m.principal ?? m.total_amount;
						m.transfer_date = formattedDateTime;

						m.state = this.state._response.transactions[index].status;
						m.id = '';
					}

					if (this.state._response.subDetails && m.topup_date) {
						for (let i = 0; i < this.state._response.subDetails.length; i++) {
							if (this.state._response.subDetails[i].id === m.user_id) {
								m.customer_name = capitalizeFirstLetter(
									`${this.state._response.subDetails[i].first_name} ${this.state._response.subDetails[i].last_name}`
								);
							}
						}

						m.transfer_type = 'TOPUPS';

						m.action = 'N/A';
						m.amortization_table = 'N/A';
						m.principal = m.principal ?? m.total_amount;
						m.transfer_date = formattedDateTime;

						m.state = this.state._response.transactions[index].status;
						m.id = '';
					}

					// if loans or transfers
					if (
						(this.state._response.senderQueries && m.installment_date) ||
						m.start_date ||
						m.installment_date
					) {
						for (let i = 0; i < this.state._response.senderQueries.length; i++) {
							if (
								this.state._response.senderQueries[i].id &&
								this.state._response.senderQueries[i].id === m.accepted_by
							) {
								m.sender_first_name = capitalizeFirstLetter(
									this.state._response.senderQueries[i].first_name +
										' ' +
										this.state._response.senderQueries[i].last_name
								);

								m.transfer_date = formattedDateTime;

								// m.transfer_type = this.state._response.senderQueries[i].type;
								m.transfer_type = 'Loan Fund Transfer';

								m.loan_id = m.id;
								m.principal = m.principal;
							}
							if (
								(this.state._response.senderQueries[i].email == m.email_creator ||
									this.state._response.senderQueries[i].email == m.email_acceptor) &&
								this.state._response.senderQueries[i].email
							) {
								m.sender_first_name = capitalizeFirstLetter(m.creator_name);
								m.transfer_date = formattedDateTime;
								// m.transfer_type = this.state._response.senderQueries[i].type;

								m.transfer_type = 'Installments Transaction';

								m.loan_id = m.id;

								m.channel = 'LendAmi';

								m.principal = parseFloat(m.emi_amount) + parseFloat(m.transaction_fee);
								// m.principal = amountQuery ? amountQuery.emi_amount : 0;

								m.state = m.state;
							}
						}

						m.action = 'Review';
						m.amortization_table = 'Transaction';

						if (
							m.disbursal_mode === 'ACH' ||
							(m.disbursal_mode === null && m.latest_disbursal_mode === 'ACH')
						) {
							m.channel = 'LendAmi';
							m.principal = m.principal_plus_fee;
						} else if (
							m.disbursal_mode === 'OFFLINE' ||
							(m.disbursal_mode === null && m.latest_disbursal_mode === 'OFFLINE')
						) {
							m.channel = 'Cash/Check';
						} else if (m.disbursal_mode === null || m.latest_disbursal_mode === null) {
							m.channel = 'N/A';
						}
					}

					// for loans or transfers
					if (
						(this.state._response.receiverQueries && m.installment_date) ||
						m.start_date ||
						m.installment_date
					) {
						for (let i = 0; i < this.state._response.receiverQueries.length; i++) {
							if (
								this.state._response.receiverQueries[i].id &&
								this.state._response.receiverQueries[i].id === m.created_by
							) {
								m.receiver_first_name = capitalizeFirstLetter(
									this.state._response.receiverQueries[i].first_name +
										' ' +
										this.state._response.receiverQueries[i].last_name
								);

								m.transfer_date = formattedDateTime;
								// m.transfer_type = this.state._response.receiverQueries[i].type;

								m.transfer_type = 'Loan Fund Transfers';
								m.loan_id = m.id;
							}

							if (
								(this.state._response.receiverQueries[i].email == m.email_acceptor ||
									this.state._response.receiverQueries[i].email == m.email_creator) &&
								this.state._response.receiverQueries[i].email
							) {
								m.receiver_first_name = capitalizeFirstLetter(m.acceptor_name);
							}

							if (m.email_acceptor || m.email_creator) {
								m.transfer_date = formattedDateTime;
								// m.transfer_type = this.state._response.receiverQueries[i].type;
								m.transfer_type = 'Installment Transactions';
								m.loan_id = m.loan_id;

								m.channel = 'LendAmi';

								m.principal = parseFloat(m.emi_amount) + parseFloat(m.transaction_fee);

								// m.principal = Number(m.amount);

								m.state = m.state;
							}
						}
					}
				}

				if (this.state._response.table.toLowerCase() == 'loans') {
					for (let i = 0; i < transactionColumns.length; i++) {
						if (transactionColumns[i].name === 'transfer_type') {
							transactionColumns[i].label = 'Loan Type';
						}
					}
					this.state._uniqueIdsForLoan.map(value => {
						if (value.id === m.id) {
							// m.overdue_amount = value.overdue_amount;
							// m.paid_amount = value.paid_amount;
							// m.transfer_type = value.loan_type;
							m.transfer_type = 'Loan Fund Transfers';
						}
					});
					const maxLoopLength = Math.max(
						this.state._response.senderQueries.length,
						this.state._response.receiverQueries.length
					);

					m.principal = m.principal;

					if (
						m.disbursal_mode === 'ACH' ||
						(m.disbursal_mode === null && m.latest_disbursal_mode === 'ACH')
					) {
						m.channel = 'LendAmi';
						m.principal = m.principal_plus_fee;
					} else if (
						m.disbursal_mode === 'OFFLINE' ||
						(m.disbursal_mode === null && m.latest_disbursal_mode === 'OFFLINE')
					) {
						m.channel = 'Cash/Check';
					} else if (m.disbursal_mode === null || m.latest_disbursal_mode === null) {
						m.channel = 'N/A';
					}

					for (let i = 0; i < maxLoopLength; i++) {
						const senderQuery = this.state._response.senderQueries.find(
							query => query.id === m.accepted_by
						);

						const receiverQuery = this.state._response.receiverQueries.find(
							query => query.id === m.created_by
						);
						m.action = 'Review';
						m.amortization_table = 'Transaction';

						if (senderQuery || receiverQuery) {
							if (senderQuery) {
								m.sender_first_name = capitalizeFirstLetter(
									senderQuery.first_name + ' ' + senderQuery.last_name
								);
							} else {
								m.sender_first_name = capitalizeFirstLetter(m.invited_name);
							}
							if (receiverQuery) {
								m.receiver_first_name = capitalizeFirstLetter(
									receiverQuery.first_name + ' ' + receiverQuery.last_name
								);
							} else {
								m.receiver_first_name = capitalizeFirstLetter(m.invited_name);
							}
							m.transfer_date = formattedDateTime;
							m.emi_amount = m.emi_amount ?? m.total_amount;
							m.emi_amount = m.emi_amount;
							m.transfer_type = 'Loan Fund Transfer';
							m.receiver_first_name = capitalizeFirstLetter(
								receiverQuery.first_name + ' ' + receiverQuery.last_name
							);
							m.loan_id = m.id;
						} else {
							m.sender_first_name = 'N/A';
							m.loan_id = m.id;
							m.sender_last_name = '';
							m.receiver_first_name = 'N/A';
							m.receiver_last_name = '';
							m.transfer_date = formattedDateTime;

							// m.transfer_type = this.state._response.table ?? "";
							// m.emi_amount = m.emi_amount ?? m.total_amount;
						}
					}
				}

				if (this.state._response.table.toLowerCase() == 'loan_installments') {
					for (let i = 0; i < transactionColumns.length; i++) {
						if (transactionColumns[i].name === 'transfer_type') {
							transactionColumns[i].label = 'Type';
						}
					}
					this.state._uniqueIdsForLoan.map(value => {
						if (value.id === m.loan_id) {
							m.overdue_amount = value.overdue_amount;
							m.paid_amount = value.paid_amount;
						}
					});
					const maxLoopLength = Math.max(
						this.state._response.senderQueries.length,
						this.state._response.receiverQueries.length
					);

					for (let i = 0; i < maxLoopLength; i++) {
						let senderQuery;
						let receiverQuery;

						senderQuery =
							this.state._response.senderQueries.find(query => query.email === m.email_creator) ||
							this.state._response.senderQueries.find(query => query.email === m.email_acceptor);

						receiverQuery =
							this.state._response.receiverQueries.find(query => query.email === m.email_acceptor) ||
							this.state._response.receiverQueries.find(query => query.email === m.email_creator);

						// const amountQuery = this.state._response.amountQueries.find(query => query.id == m.id);

						// m.emi_amount = amountQuery ? amountQuery.emi_amount : 0;
						m.action = 'Review';
						m.amortization_table = 'Transaction';
						m.transfer_date = formattedDateTime;
						// m.transfer_type = this.state._response.table ?? ''; // this is for transfer type, im guessing this is rather different than "loan_type" since transfer is not "loan",
						m.principal = parseFloat(m.emi_amount) + parseFloat(m.transaction_fee);

						m.state = m.state;

						m.transfer_type = 'Installment Transactions';

						m.channel = 'LendAmi';

						// m.principal = Number(m.amount);

						if (senderQuery && receiverQuery) {
							m.sender_first_name = capitalizeFirstLetter(
								senderQuery.first_name + ' ' + senderQuery.last_name
							);
							// m.sender_last_name = senderQuery.last_name;
							m.receiver_first_name = capitalizeFirstLetter(
								receiverQuery.first_name + ' ' + receiverQuery.last_name
							);
							// m.receiver_last_name = receiverQuery.last_name;
							m.loan_id = m.id;
						} else {
							m.sender_first_name = 'N/A';
							m.sender_last_name = '';
							m.receiver_first_name = 'N/A';
							m.receiver_last_name = '';
							m.loan_id = m.loan_id;
						}
					}
				}
				return m;
			});
		}

		const columns = transactionColumns ?? this.props.columns;

		const downloadCsv = async () => {
			const Data = transactionData;
			const Title = 'Transactions';

			Data.forEach(item => {
				item.loan_id = item.loan_id || item.id || 'N/A';
				item.customer_name = item.customer_name || 'N/A';
				item.transfer_date = convertToPhilippinesTime(item.transfer_date);
				item.sender_name = item.sender_first_name
					? `${item.sender_first_name || ''} ${item.sender_last_name || ''}`.trim()
					: item.invited_name || 'N/A';
				item.receiver_name = item.receiver_first_name
					? `${item.receiver_first_name || ''} ${item.receiver_last_name || ''}`.trim()
					: item.invited_name || 'N/A';
				item.principal = `₱${CommaSeparator(item.principal)}`;
			});

			const timestamp = moment().toISOString();
			const fileName = `${Title}-${timestamp}.xlsx`;
			const wb = new Exceljs.Workbook();
			const ws = wb.addWorksheet('Report', {
				properties: { tabColor: { argb: 'FFC0000' } },
				pageSetup: {
					fitToPage: true,
					fitToHeight: 5,
					fitToWidth: 7
				}
			});

			const newColumns = [
				{ name: 'transfer_date', label: 'Date/Time' },
				{ name: 'loan_id', label: 'Loan ID' },
				{ name: 'customer_name', label: 'Customer Name' },
				{ name: 'transfer_type', label: 'Type' },
				{ name: 'sender_name', label: 'From' },
				{ name: 'receiver_name', label: 'To' },
				{ name: 'state', label: 'Status' },
				{ name: 'channel', label: 'Channel' },
				{ name: 'principal', label: 'Amount(₱) + (LendAmi fee)' },
				{ name: 'amortization_table', label: 'Amortization Table' },
				{ name: 'action', label: 'Action' }
			].map(col => ({
				key: col.name,
				header: col.label
			}));

			ws.columns = newColumns;
			ws._rows.height = 25;
			ws._rows.font = {
				size: 10,
				bold: true,
				color: { argb: 'FFFFFF' }
			};
			ws._rows.alignment = { horizontal: 'center', vertical: 'middle' };
			ws._rows.fill = {
				type: 'pattern',
				pattern: 'solid',
				bgColor: { argb: '000000' }
			};

			ws.columns.forEach(function (column) {
				let maxColumnLength = column.header?.toString()?.length;

				Data.forEach(function (row) {
					const cellValue = row[column.key] || '';
					const cellLength = cellValue?.toString()?.length;

					if (cellLength > maxColumnLength) {
						maxColumnLength = cellLength;
					}
				});
				column.style = {
					alignment: { horizontal: 'center', vertical: 'middle' }
				};
				column.width = maxColumnLength > 10 ? maxColumnLength + 5 : 10 + 5;
			});

			try {
				Data.forEach(d => {
					const row = {};
					newColumns.forEach(col => {
						const fieldData = d[col.key] ? d[col.key] : '';
						row[col.key] = fieldData;
					});
					return ws.addRow(row);
				});
				await wb.xlsx
					.writeBuffer()
					.then(buffer => FileSaver.saveAs(new Blob([buffer]), `${fileName}`))
					.catch(err => console.log('Error writing excel export', err));
			} catch (error) {
				console.log(error.message);
			}
		};

		const isTransactionData = transactionData ?? false;
		const currentQuery = qs.parse(window.location.search);

		options = {
			customToolbar: () => {
				if (this.props.match.path === '/admin/transactions') {
					return isTransactionData.length !== 0 ? (
						<div style={{ position: 'relative', right: 50, top: -35 }} onClick={downloadCsv}>
							<Tooltip arrow title="Download Report">
								<DownloadOutlined style={{ fontSize: 20, cursor: 'pointer' }} />
							</Tooltip>
						</div>
					) : null;
				}
			},
			sort: this.props.sort,
			search: false,
			serverSide: true,
			count: _totalRowsCount,
			page: _currentPage,
			print: false,
			pagination: this.state._isLoading ? false : true,
			download: false,
			filter: false,
			selectableRows: 'none',
			rowsPerPage: currentQuery.limit || _limit,
			search:
				this.props.match.path === '/admin/tenant/forms/:id' ? true : this.props.match.path === '/admin/tenants',
			textLabels: {
				body: {
					noMatch: this.state._isLoading ? (
						<Spin size="large" indicator={<LoadingOutlined />}>
							{' '}
							Loading data please wait...
						</Spin>
					) : (
						'Sorry, no matching records found'
					)
				}
			},

			responsive: 'scroll',
			onSearchChange: value => {
				this.globalSearchHandler(value);
			},

			onChangePage: debounce(async page => {
				const queryParams = new URLSearchParams(window.location.search);

				queryParams.set('page', page);

				const queryString = queryParams.toString();
				window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);

				await this.setState({ _currentPage: page, _paginationButtonClicked: true });
				this.setTableData();
			}, 800), // Adjust the debounce delay as needed

			onTableChange: (action, tableState) => {
				switch (action) {
					case 'onSearchClose':
						this.searchCloseHandler();
						break;
					case 'propsUpdate':
						this.propsUpdateHandler(tableState);
						break;
					default:
						return false;
				}
			},
			onChangeRowsPerPage: async numberOfRows => {
				currentQuery.limit = numberOfRows;
				this.props.history.push({
					search: qs.stringify(currentQuery)
				});
				await this.setState({ _limit: numberOfRows, _currentPage: 0 });
				this.setTableData();
			},
			onColumnSortChange: async changedColumn => {
				let orderDir = 'desc';
				if (this.state._orderDir === 'desc') {
					orderDir = 'asc';
				}
				const currentQuery = qs.parse(window.location.search);
				currentQuery.order = changedColumn;
				currentQuery.orderDir = orderDir;
				this.props.history.push({
					search: qs.stringify(currentQuery)
				});
				await this.setState({
					_orderDir: orderDir,
					_order: changedColumn
				});
				this.setTableData();
			}
		};
		const getUser = async () => {
			let queryUrl = '?';		
			const params = new URLSearchParams(this.props.location.search);
			const searchTerm = params.get('globalSearch')?.trim()?.toLowerCase() || ''; // Ensure safe search term
			console.log('Search Term:', searchTerm);
			if (this.state._modifiedPage === false) {
				queryUrl += this.state._defaultQuery;
			} else {
				queryUrl += this.props.customFilterQuery ? this.props.customFilterQuery : this.state._paginationQuery;
			}
			// Filter users based on multiple fields
			const response = await this.props.dataSourceHandler(queryUrl);
			if (response && response[this.props.dataSourceName]?.length !== 0) {
				const filteredUsers = (response[this.props.dataSourceName] || [])?.filter(d => {
					const fullName = `${(d.first_name || '').trim()} ${(d.last_name || '').trim()}`.toLowerCase();
					const isMatch = field => field?.toLowerCase()?.includes(searchTerm); // Reusable match logic

					const matches = [
						isMatch(d.first_name),
						isMatch(d.last_name),
						isMatch(fullName),
						isMatch(d.email),
						isMatch(d.phone),
						isMatch(d.address),
						isMatch(d.city),
						isMatch(d.postal_code)
					];

					return matches.some(match => match);
				});
				return { filteredUsers, searchTerm };
			}
		};

		return (
			<MuiThemeProvider theme={this.getMuiTheme()}>
				<MUIDataTable
					columns={columns || []}
					data={
						getUser().searchTerm
							? getUser().filteredUsers
							: this.props.match.path === '/admin/transactions'
							? transactionData
							: _data
					}
					options={this.props.options || options}
					title={
						this.props.match.path !== '/admin/customer/custom-view/:id'
							? this.props.title
							: this.props.match.path === '/admin/transactions'
							? 'Transactions'
							: this.props.title
					}
				/>
			</MuiThemeProvider>
		);
	}
}

export default withRouter(hot(module)(Table));
